import { useState, useMemo } from 'react';
import { Combobox, Field, Input, Option, Textarea } from '@fluentui/react-components';
import type { Client } from '../../../models/Client';
import type { Offer } from '../../../models/Offer';
import type { ExchangeRate } from '../../../models/ExchangeRate';

export const OfferHeader = ({ offer, clients, exchangeRates: _exchangeRates, onChange }: {
  offer: Offer;
  clients: Client[];
  exchangeRates: ExchangeRate[];
  onChange: (value: Offer) => void;
}) => {
  const [clientSearch, setClientSearch] = useState('');

  const selectedClient = clients.find((c) => c.cr_crm_clientid === offer.cr_crm_clientid);

  const filteredClients = useMemo(() => {
    const q = clientSearch.toLowerCase();
    return clients
      .filter((c) => !q || c.cr_crm_companyname.toLowerCase().includes(q))
      .slice(0, 100);
  }, [clients, clientSearch]);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 }}>
      <Field label="Client">
        <Combobox
          placeholder="Search a client..."
          value={selectedClient ? selectedClient.cr_crm_companyname : clientSearch}
          onChange={(e) => {
            setClientSearch(e.target.value);
            if (!e.target.value) onChange({ ...offer, cr_crm_clientid: '', cr_crm_client: undefined });
          }}
          onOptionSelect={(_, data) => {
            const client = clients.find((c) => c.cr_crm_clientid === data.optionValue);
            onChange({
              ...offer,
              cr_crm_clientid: data.optionValue ?? '',
              cr_crm_client: client ? { cr_crm_companyname: client.cr_crm_companyname } : undefined,
            });
            setClientSearch('');
          }}
          selectedOptions={offer.cr_crm_clientid ? [offer.cr_crm_clientid] : []}
        >
          {filteredClients.map((c) => (
            <Option key={c.cr_crm_clientid} value={c.cr_crm_clientid} text={c.cr_crm_companyname}>
              {c.cr_crm_companyname}
            </Option>
          ))}
        </Combobox>
      </Field>
      <Field label="Reference"><Input value={offer.cr_crm_reference} readOnly /></Field>
      <Field label="Exchange rate (USD/TND)">
        <Input type="number" step="0.001" value={String(offer.cr_crm_exchangerateval)} onChange={(_, data) => onChange({ ...offer, cr_crm_exchangerateval: Number(data.value) || 0 })} />
      </Field>
      <Field label="Tax rate"><Input type="number" value={String(offer.cr_crm_taxrate)} onChange={(_, data) => onChange({ ...offer, cr_crm_taxrate: Number(data.value) })} /></Field>
      <Field label="Valid until"><Input type="date" value={offer.cr_crm_validuntil?.slice(0, 10) ?? ''} onChange={(_, data) => onChange({ ...offer, cr_crm_validuntil: data.value ? new Date(data.value).toISOString() : undefined })} /></Field>
      <Field label="Notes" style={{ gridColumn: '1 / -1' }}><Textarea rows={4} value={offer.cr_crm_notes ?? ''} onChange={(_, data) => onChange({ ...offer, cr_crm_notes: data.value })} /></Field>
    </div>
  );
};
